import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';
import { categories } from '@/mocks/data';

export default function CTASection() {
  const latestArticles = articles.slice(0, 4);

  return (
    <section className="py-16 md:py-20 bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-background-50 mb-4">
              关于饭岛爱纪念网
            </h2>
            <p className="text-background-300 leading-relaxed mb-6">
              饭岛爱（1972-2008），日本娱乐界最具传奇色彩的女性之一。从AV女优到畅销作家、电视主持人，她的人生轨迹震撼了整个时代。她用真实的生命诠释了勇气的含义，她的自传《柏拉图式性爱》改变了无数人对女性、对社会的看法。
            </p>
            <p className="text-background-300 leading-relaxed mb-8">
              本站致力于保存和传播饭岛爱的文化影响力。我们收集整理了她的生平经历、代表作品、社会影响以及来自世界各地的纪念文章，希望让更多人了解这位非凡女性的人生故事。
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/about"
                className="px-6 py-2.5 bg-accent-500 text-background-50 font-medium rounded-md hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                了解更多
              </Link>
              <Link
                to="/category/life-experience"
                className="px-6 py-2.5 border border-background-600 text-background-200 font-medium rounded-md hover:bg-background-800 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                阅读文章
              </Link>
            </div>
          </div>

          <div className="flex flex-col gap-4">
            <h3 className="font-heading text-lg font-semibold text-background-100">最新文章</h3>
            {latestArticles.map((article) => {
              const cat = categories.find((c) => c.slug === article.category);
              return (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="flex items-start gap-4 p-3 rounded-lg bg-background-800/50 hover:bg-background-800 transition-colors cursor-pointer group"
                >
                  <div className="w-16 h-16 rounded-md overflow-hidden flex-shrink-0">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top"
                      loading="lazy"
                    />
                  </div>
                  <div className="min-w-0">
                    {cat && (
                      <span className="text-xs text-accent-400 font-label">{cat.name}</span>
                    )}
                    <h4 className="text-sm text-background-100 font-medium line-clamp-1 group-hover:text-accent-300 transition-colors mt-0.5">
                      {article.title}
                    </h4>
                    <p className="text-xs text-background-400 mt-1">{article.date}</p>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}